<template>
  <div>
    <el-row type="flex" justify="center">
      <el-col :lg="24" :xl="20">
        <ra-card>
          <template slot="header">
            <div
              v-if="userCan('auth', 'apiclient.create')"
              class="w-100 is-flex is-align-center is-justify-end"
            >
              <el-button
                type="primary"
                size="medium"
                @click="command({ action: 'add' })"
                >Create API Keys</el-button
              >
            </div>
          </template>
          <template slot="content">
            <el-table
              v-loading="loading"
              :data="pageData"
              :empty-text="noDataMessage"
            >
              <el-table-column>
                <template slot="header">Name</template>
                <template slot-scope="scope">
                  <p>{{ scope.row.name }}</p>
                </template>
              </el-table-column>

              <el-table-column>
                <template slot="header">API Key ID</template>
                <template slot-scope="scope">
                  <p>{{ scope.row.key.slice(0, 3) }} **** **** **** ****</p>
                </template>
              </el-table-column>

              <el-table-column>
                <template slot="header">Created At</template>
                <template slot-scope="scope">
                  <p>{{ scope.row.created_at }}</p>
                </template>
              </el-table-column>
              <el-table-column>
                <template slot="header">Updated At</template>
                <template slot-scope="scope">
                  <p>{{ scope.row.modified_at }}</p>
                </template>
              </el-table-column>
              <el-table-column>
                <template slot="header">Status</template>
                <template slot-scope="scope">
                  <el-tag
                    :type="scope.row.status_id === 1 ? 'success' : 'warning'"
                    size="mini"
                  >
                    {{ scope.row.status && scope.row.status.label }}
                  </el-tag>
                </template>
              </el-table-column>

              <el-table-column
                v-if="userCan('auth', 'apiclient.update')"
                width="60"
              >
                <template slot-scope="scope">
                  <el-dropdown class="more" @command="command">
                    <span>
                      <i class="ra-icon--more-vertical"></i>
                    </span>
                    <el-dropdown-menu slot="dropdown">
                      <el-dropdown-item
                        icon="ra-icon--edit"
                        :command="{ action: 'edit', api: scope.row }"
                      >
                        Edit</el-dropdown-item
                      >
                      <el-dropdown-item
                        icon="ra-icon--trash"
                        :command="{ action: 'delete', api: scope.row }"
                      >
                        Delete</el-dropdown-item
                      >
                    </el-dropdown-menu>
                  </el-dropdown>
                </template>
              </el-table-column>
            </el-table>
            <ra-pagination
              v-if="dataFound"
              :from="from"
              :to="to"
              :total="total"
              :pageSize="pagination.perPage"
              :current-page.sync="currentPage"
            />
          </template>
        </ra-card>
      </el-col>
    </el-row>
    <api-key-form
      :show.sync="apiKeyForm.visible"
      :action="apiKeyForm.action"
      :data="apiKeyForm.data"
      :api="apiKeyForm.data"
      @success="getApiKeys"
    />
  </div>
</template>

<script>
import { orderBy } from "@/lib/utils";
import apiConstants from "@/apiConstants.js";

export default {
  name: "DevelopersApi",
  components: {
    ApiKeyForm: () => import("@/components/Developers/ApiKeyForm.vue")
  },

  data() {
    return {
      loading: false,
      pageData: [],
      currentPage: 1,
      pagination: {
        perPage: 20,
        currentPage: 1,
        total: 0
      },
      noDataMessage: "No API Keys(s) available",
      noAccessCodes: apiConstants.NO_ACCESS_CODES,
      apiKeyForm: {
        visible: false,
        action: "add",
        data: {}
      }
    };
  },

  computed: {
    to() {
      let highBound = this.from + this.pagination.perPage;
      if (this.total < highBound) {
        highBound = this.total;
      }
      return highBound;
    },

    from() {
      return this.pagination.perPage * (this.currentPage - 1);
    },

    total() {
      return this.pagination.total;
    },

    dataFound() {
      return !!this.pageData.length;
    }
  },

  methods: {
    create() {
      this.$router.push({ name: "settings.api.create" });
    },

    deleteApiKey(key) {
      this.$confirm(`Do you really want to delete ${key.name} ?`, "Warning", {
        confirmButtonText: "OK",
        cancelButtonText: "Cancel",
        type: "warning"
      })
        .then(() => {
          const keyId = key.id;
          const apiUrl = `api/clients/${keyId}`;
          const body = {
            status_id: apiConstants.GLOBAL_STATUS.REMOVED
          };
          this.$http
            .post(apiUrl, {
              body: body,
              method: "PUT"
            })
            .then(response => {
              const resData = response.data;
              if (resData.status === "error") {
                this.handleErrors(resData);
              } else {
                this.notification(
                  "Completed",
                  `API key ${key.name} deleted successfully`,
                  "success"
                );
                this.getApiKeys();
              }
            })
            .catch(() => {
              this.notification("Error", "An unknown error occurred", "danger");
            });
        })
        .catch(() => {});
    },

    command(command) {
      this.apiKeyForm.action = command.action;
      this.apiKeyForm.data = { ...command.api };

      switch (command.action) {
        case "add":
          this.apiKeyForm.data = {};
          this.apiKeyForm.visible = true;
          break;
        case "edit":
          this.apiKeyForm.visible = true;
          break;
        case "delete":
          this.deleteApiKey(command.api);
          break;
        default:
          break;
      }
    },

    getPaginationParams() {
      const { currentPage, pagination } = this;
      return `page_size=${pagination.perPage}&page=${currentPage}`;
    },

    getApiKeys(customParams = "") {
      this.loading = true;
      const params = `&embeds=["status"]${customParams}`;
      const apiUrl = "api/clients";
      const sortBy = orderBy("created_at");

      this.$http
        .post(apiUrl, {
          method: "GET",
          params: `${params}&${this.getPaginationParams()}${sortBy}`
        })
        .then(response => {
          this.loading = false;
          const resData = response.data;
          if (resData.status === "error") {
            this.handleErrors(resData);
          } else {
            this.pageData = resData.list;
            this.pagination.total = resData.pagination.total_count;
          }
        })
        .catch(() => {
          this.notification("Error", "An unknown error occurred", "danger");
        });
    }
  },

  created() {
    this.getApiKeys();
  },

  watch: {
    currentPage() {
      this.getApiKeys();
    }
  }
};
</script>

<style lang="scss" scoped></style>
